var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21949 17.8972C6.29282 18.0412 6.40455 18.162 6.5423 18.2463C6.68006 18.3306 6.83847 18.3752 6.99999 18.375H21C21.1613 18.3749 21.3195 18.3301 21.457 18.2457C21.5944 18.1613 21.7059 18.0406 21.7791 17.8968C21.8522 17.753 21.8842 17.5918 21.8715 17.431C21.8588 17.2702 21.8018 17.116 21.707 16.9855L14.707 7.3605C14.6258 7.24913 14.5194 7.15853 14.3966 7.09606C14.2737 7.03359 14.1378 7.00103 14 7.00103C13.8622 7.00103 13.7263 7.03359 13.6034 7.09606C13.4806 7.15853 13.3742 7.24913 13.293 7.3605L6.29299 16.9855C6.19816 17.1157 6.14111 17.2696 6.12815 17.4302C6.11518 17.5907 6.14678 17.7517 6.21949 17.8955",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleUpIcon);
export default __webpack_public_path__ + "static/media/triangle-up-icon.28985680bc7f43d1bf02738219adcbe7.svg";
export { ForwardRef as ReactComponent };